import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withTranslation } from 'providers/GILT.provider';
import { selectCurrentSalonId } from 'selectors/currentSalon.selectors';

import {
  fetchManualMessagesOnlyCampaigns,
  fetchMarketingCampaigns,
  showCampaignDetails,
  sortCampaign,
  sortCampaignClient,
} from 'clientCommunications/actions';
import AutomatedMessagesLayout from 'clientCommunications/components/Automate/AutomatedMessagesLayout';
import CampaignsHeader from 'clientCommunications/components/Campaigns/CampaignsHeader';
import TableBlastSmsResultComponent from 'clientCommunications/components/Campaigns/TableBlastSmsResult';
import TableCampaignsResultComponent from 'clientCommunications/components/Campaigns/TableCampaignsResult';
import TableSortHeader from 'clientCommunications/components/Campaigns/TableSortHeader';

class CampaignsLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = { subTab: 0 };
  }

  UNSAFE_componentWillMount() {
    const { salonId, fetchMarketingCampaigns, fetchManualMessagesOnlyCampaigns } = this.props;

    fetchMarketingCampaigns(salonId);
    fetchManualMessagesOnlyCampaigns(salonId);
  }

  showContent = (id) => {
    const { showCampaignDetails, salonId } = this.props;
    showCampaignDetails(salonId, id, true);
  };

  hideContent = (id) => {
    const { showCampaignDetails, salonId } = this.props;
    showCampaignDetails(salonId, id, false);
  };

  switchTabs = (tabNum) => {
    this.setState({ subTab: tabNum });
    window.scrollTo(0, 0);
  };

  render() {
    const { subTab } = this.state;

    const {
      revenueGenerated,
      bookingsRecieved,
      clientsMessaged,
      campaignsSent,
      bookingsRecievedDirect,
      revenueGeneratedDirect,
      clientsMessagedDirect,
      campaignsSentDirect,
      bookingsRecievedAuto,
      clientsMessagedAuto,
      revenueGeneratedAuto,
      campaignsSentAuto,
      blastSms,
      campaigns,
      blastSmsByMonth,
      showCampaignDetails,
      groupOrderChanged,
      oneToOneSmsByMonth,
      sortCampaign,
      salonId,
      sortCampaignClient,
      t,
    } = this.props;

    return (
      <>
        <div className="campaigns-container tbl-campaign">
          {subTab === 0 && (
            <CampaignsHeader
              campaignsSent={campaignsSent}
              clientsMessaged={clientsMessaged}
              revenueGenerated={revenueGenerated}
              bookingsRecieved={bookingsRecieved}
            />
          )}
          {subTab === 1 && (
            <CampaignsHeader
              campaignsSent={campaignsSentDirect}
              clientsMessaged={clientsMessagedDirect}
              revenueGenerated={revenueGeneratedDirect}
              bookingsRecieved={bookingsRecievedDirect}
            />
          )}
          {subTab === 2 && (
            <CampaignsHeader
              campaignsSent={campaignsSentAuto}
              clientsMessaged={clientsMessagedAuto}
              revenueGenerated={revenueGeneratedAuto}
              bookingsRecieved={bookingsRecievedAuto}
            />
          )}

          <div className={`messages-container ${subTab !== 0 ? 'manual' : 'automated'}`}>
            <div className="messages-tab-nav">
              <button onClick={() => this.switchTabs(0)} className={subTab === 0 ? 'tab active-tab' : 'tab '}>
                {t('campaigns.blastTextTab')}
              </button>
              <button onClick={() => this.switchTabs(1)} className={subTab === 1 ? 'tab active-tab' : 'tab '}>
                {t('campaigns.clientTextsTab')}
              </button>
              <button onClick={() => this.switchTabs(2)} className={subTab === 2 ? 'tab active-tab' : 'tab '}>
                {t('campaigns.automatedTextsTab')}
              </button>
            </div>
            {subTab === 0 && (
              <div className="sticky-container">
                {blastSms && (
                  <>
                    <TableSortHeader sortFunction={sortCampaign} />
                    <TableBlastSmsResultComponent
                      campaigns={campaigns}
                      hideContent={this.hideContent}
                      showContent={this.showContent}
                      sortFunction={sortCampaignClient}
                      blastSmsByMonth={blastSmsByMonth}
                    />
                  </>
                )}
              </div>
            )}
            {subTab === 1 && (
              <div className="sticky-container">
                <TableSortHeader sortFunction={sortCampaign} />
                <TableCampaignsResultComponent
                  blastSms={blastSms}
                  oneToOneSmsByMonth={oneToOneSmsByMonth}
                  hideContent={this.hideContent}
                  showContent={this.showContent}
                  sortFunction={sortCampaignClient}
                  groupOrderChanged={groupOrderChanged}
                  showCampaignDetails={showCampaignDetails}
                  salonId={salonId}
                />
              </div>
            )}
            {subTab === 2 && <AutomatedMessagesLayout />}
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  salonId: selectCurrentSalonId(state),
  ...state.clientCommunications,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchMarketingCampaigns,
      fetchManualMessagesOnlyCampaigns,
      showCampaignDetails,
      sortCampaignClient,
      sortCampaign,
    },
    dispatch,
  );

const CampaignsLayoutHoc = connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CampaignsLayout));

export default CampaignsLayoutHoc;
